import React from "react";
import { Button } from "primereact/button";
import { imageList } from "@/core/utils/imageList";
import { OrganizationViewModel } from "../viewmodel/OrganizationViewModel";

interface PartnerMember {
  id: string;
  logo_uri: string;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  description: string;
  job_title: string;
  is_admin?: boolean;
}

interface TeamMembersListProps {
  members: PartnerMember[];
  onRemoveMember: (memberId: string, memberName: string) => void;
  onMakeAdmin: (memberId: string, memberName: string) => void;
  isAdmin: boolean;
}

export const TeamMembersList: React.FC<TeamMembersListProps> = ({
  members,
  onRemoveMember,
  onMakeAdmin,
  isAdmin,
}) => {
  return (
    <div className="memberList">
      <div className="memberList-item memberList-header">
        <div>Name</div>
        <div></div>
        <div>Role</div>
        <div></div>
      </div>
      {members.map((member) => (
        <div key={member.id} className="memberList-item">
          <div className="memberList-item-image">
            <img
              src={
                member.logo_uri && member.logo_uri !== ""
                  ? member.logo_uri
                  : imageList.noimage
              }
              alt=""
            />
          </div>
          <div className="memberList-item-texts">
            <div className="memberList-item-texts-name">
              {member.firstname} {member.lastname}
            </div>
            <div className="memberList-item-texts-email">{member.email}</div>
          </div>
          <div className="memberList-item-role">
            {member.is_admin ? "Admin" : "Member"}
          </div>
          {isAdmin && !member.is_admin && (
            <div className="memberList-item-actions">
              <div
                className="removeMember"
                onClick={() => {
                  onRemoveMember(
                    member.id,
                    `${member.firstname} ${member.lastname}`
                  );
                }}
              >
                Remove
              </div>
              {!member.is_admin && isAdmin && (
                <div
                  className="makeAdmin"
                  onClick={() => {
                    onMakeAdmin(
                      member.id,
                      `${member.firstname} ${member.lastname}`
                    );
                  }}
                >
                  Make admin
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
